import React from "react";
import {
    useAppSelector,
} from "../../../../app/hooks";
import Account from "../../components/Account";
import { formatCurrencyAmount } from "../../../../utils/currency";
import RequestForSettlement from "../../components/RequestForSettlement";
import { useParams } from "react-router-dom";
import VirtualAccountTransactionTable from "../../components/VirtualAccountTransactionTable";

const toolTipText =
    "This balance will be automatically swept to your settlement balance at 1:00AM daily.";

const VirtualAccounts = () => {
    const { currencyCode } = useParams()
    const capitalizedCurrencyCode = currencyCode.toUpperCase()

    const { wallets } = useAppSelector(
        (state) => state.wallets,
    );

    const virtualAccountOfInterest = wallets.find(
        (curr) => curr?.currency === capitalizedCurrencyCode,
    );

    return (
        <div>
            <Account
                title={`${capitalizedCurrencyCode} Virtual account balance`}
                balance={formatCurrencyAmount(
                    capitalizedCurrencyCode,
                    virtualAccountOfInterest?.holdBalance?.toFixed(2) ||
                    0,
                )}
                tooltipText={toolTipText}
            />

            <RequestForSettlement />

            <VirtualAccountTransactionTable currencyOfInterest={capitalizedCurrencyCode} />

        </div>
    );
};

export default VirtualAccounts;
